import {CheckGlyph} from '@/components/ui/icons'

export function HappyStateCard({title, body, testId}: {title: string; body: string; testId: string}) {
  return (
    <div className="surface flex items-center gap-3.5 p-5" data-testid={testId}>
      <span className="flex h-10 w-10 shrink-0 items-center justify-center rounded-lg bg-accent text-primary">
        <CheckGlyph size={18} />
      </span>
      <div>
        <p className="text-[15px] font-semibold">{title}</p>
        <p className="text-[13px] text-muted-foreground">{body}</p>
      </div>
    </div>
  )
}
